export enum EServiceRequestDamageCause {
  Burglary = 'damage_burglary',
  Collision = 'damage_collision',
  Defrosting = 'damage_defrosting',
  Electricity = 'damage_electricity',
  Explosion = 'damage_explosion',
  Fire = 'damage_fire',
  Glass = 'damage_glass',
  Oil = 'damage_oil',
  Scorching = 'damage_scorching',
  Smoke = 'damage_smoke',
  Vandalism = 'damage_vandalism',
  Water = 'damage_water',
  Weather = 'damage_weather',
}

export enum EServiceRequestStatus {
  Contacted = 'contacted',
  ExpertiseInProgress = 'expertise_in_progress', // Temporary status for demo purposes
  InProgress = 'in_progress',
  Lost = 'lost',
  QuoteInProgress = 'quote_in_progress',
  Received = 'received',
  Success = 'success',
  Trashed = 'trashed',
  WorkInProgress = 'work_in_progress',
}

export enum EServiceRequestCaller {
  OwnerLandlord = 'caller_owner_landlord',
  OwnerResident = 'caller_owner_resident',
  Renter = 'caller_renter',
}
